import {ComponentProps, forwardRef, useId} from 'react';

import SvgIcon from './SvgIcon';
import {IconType} from './types';

interface Props extends ComponentProps<typeof SvgIcon> {
  icon: IconType;
}

const Icon = forwardRef<SVGSVGElement, Props>(({icon, ...props}, ref) => {
  const clipId = useId().replace(/:/g, '_');

  return (
    <SvgIcon viewBox="0 0 24 24" {...props} ref={ref}>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24"></rect>
        </clipPath>
      </defs>
      <g clipPath={`url(#${clipId})`}>
        <text x={0} y={24} className="material-icons">
          {icon}
        </text>
      </g>
    </SvgIcon>
  );
});

export default Icon;
